import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getCourseClassroomData } from "../../service/endpoints";

export const ClassroomHandler = createAsyncThunk('ClassroomHandler', async (data) => {
  try {
    const response = await getCourseClassroomData(data);
    console.log(response.data, 'classroom');
    return response.data.response;


  } catch (error) {
    if (error.response !== undefined) {
      console.log('fail', error);
      throw error.response;
    } else
    {
      console.log(error);
      throw error.response;
    }
  }
});


const ClassroomSlice = createSlice({
  name: 'get_classroom',
  initialState: {
    isLoading: false,
    data: null,
    isError: false
  },
  extraReducers: (builder) => {
    builder.addCase(ClassroomHandler.fulfilled, (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    });
    builder.addCase(ClassroomHandler.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(ClassroomHandler.rejected, (state, action) => {
      console.log(action.state);
      state.isError = true;
      console.log(action.payload);

    });
  }

});

export default ClassroomSlice.reducer;